import { render, staticRenderFns } from "./chosePz.vue?vue&type=template&id=6295d89c&scoped=true&"
import script from "./chosePz.vue?vue&type=script&lang=js&"
export * from "./chosePz.vue?vue&type=script&lang=js&"
import style0 from "./chosePz.vue?vue&type=style&index=0&id=6295d89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6295d89c",
  null
  
)

export default component.exports